
<template>
  <header class="topnavbar-wrapper">
         <!-- START Top Navbar-->
         <nav role="navigation" class="navbar topnavbar">
            <!-- START navbar header-->
            <div class="navbar-header">
               <!-- Hamburger menu button for mobile -->
               <button 
                 class="hamburger-menu"
                 @click="toggleSidebar"
                 aria-label="Toggle menu"
               >
                 <span class="hamburger-icon"></span>
                 <span class="hamburger-icon"></span>
                 <span class="hamburger-icon"></span>
               </button>
               
               <a class="navbar-brand">
                  <div class="brand-logo">
                     <img src="../assets/calvert-logo.png" alt="Calvert Impact Capital" class="img-responsive" width="120">
                  </div>
               </a>
            </div>
            <!-- END navbar header-->
            <!-- START Nav wrapper-->
            <div class="nav-wrapper">
               <!-- START Right Navbar-->
               <ul class="nav navbar-nav navbar-right">
                  <!-- START Alert menu-->
                  <li class="dropdown dropdown-list hide">
                     <a href="#" data-toggle="dropdown">
                        <em class="icon-bell"></em>
                        <div class="label label-danger">11</div>
                     </a>
                     <!-- START Dropdown menu-->
                     <ul class="dropdown-menu animated flipInX">
                        <li>
                           <!-- START list group-->
                           <div class="list-group">
                              <!-- list item-->
                              <a href="#" class="list-group-item">
                                 <div class="media-box">
                                    <div class="pull-left">
                                       <em class="fa fa-twitter fa-2x text-info"></em>
                                    </div>
                                    <div class="media-box-body clearfix">
                                       <p class="m0">New followers</p>
                                       <p class="m0 text-muted">
                                          <small>1 new follower</small>
                                       </p>
                                    </div>
                                 </div>
                              </a>
                              <!-- list item-->
                              <a href="#" class="list-group-item">
                                 <div class="media-box">
                                    <div class="pull-left">
                                       <em class="fa fa-envelope fa-2x text-warning"></em>
                                    </div>
                                    <div class="media-box-body clearfix">
                                       <p class="m0">New e-mails</p>
                                       <p class="m0 text-muted">
                                          <small>You have 10 new emails</small>
                                       </p>
                                    </div>
                                 </div>
                              </a>
                              <!-- list item-->
                              <a href="#" class="list-group-item">
                                 <div class="media-box">
                                    <div class="pull-left">
                                       <em class="fa fa-tasks fa-2x text-success"></em>
                                    </div>
                                    <div class="media-box-body clearfix">
                                       <p class="m0">Pending Tasks</p>
                                       <p class="m0 text-muted">
                                          <small>11 pending task</small>
                                       </p>
                                    </div>
                                 </div>
                              </a>
                              <!-- last list item-->
                              <a href="#" class="list-group-item">
                                 <small>More notifications</small>
                                 <span class="label label-danger pull-right">14</span>
                              </a>
                           </div>
                           <!-- END list group-->
                        </li>
                     </ul>
                     <!-- END Dropdown menu-->
                  </li>
                  <!-- END Alert menu-->
                  <!-- START User avatar toggle-->
                  <li class="dropdown dropdown-list">
                     <!-- Button used to collapse the left sidebar. Only visible on tablet and desktops-->
                     <a href="#" id="user-block-toggle" class="dropdown-list--account" data-toggle="dropdown" aria-expanded="true">
                        <div class="dropdown-list--account__info">
                          <strong v-if="activeAccount">{{ activeAccount.accountName }}</strong>
                          <span v-if="activeAccount" class="user-block-role">{{getAccountDescription(activeAccount.accountType)}}</span>
                          <span v-if="!irAdmin && investorSince" class="user-block-investor-since">Investor since {{ investorSince }}</span>
                        </div>
                        <b class="dropdown-list--account__icon icon-arrow-down"></b>
                     </a>
                     <ul class="dropdown-menu animated flipInX">

                      <!-- Current account -->
                      <li>
                        <!-- START current account item-->
                        <div class="list-group">
                          <!-- list item-->
                          <div class="list-group-item list-group-item--current">
                            <div class="media-box">
                              <div class="pull-left">
                                <img v-if="activeAccount" :src="getAccountImgUrl(activeAccount.accountType)" alt="Avatar" width="60" height="60" class="img-thumbnail img-circle">
                              </div>
                              <div class="media-box-body clearfix">
                                <p v-if="activeAccount" class="m0">{{ activeAccount.accountName }}</p>
                                <p class="m0 text-muted">
                                  <small v-if="activeAccount">{{getAccountDescription(activeAccount.accountType)}}</small>
                                </p>
                              </div>
                              <div class="current-check">
                                <em class="fa fa-check"></em>
                              </div>
                            </div>
                          </div>
                          <!-- list item-->
                        </div>
                        <!-- END list group-->
                      </li>

                      <li v-if="!irAdmin && user.id !== undefined" class="action-widget" :class="{ disabled: !hasBeenCreatedAccount }" id="go-to-account-details">
                        <router-link
                          :to="{
                            name: 'InvestorAccountDetails', 
                            params: { id: activeAccountId } 
                          }"
                          title="Account details"
                          class="action-link">
                          <em class="fa fa-cogs"></em>
                          <span data-localize="sidebar.nav.WIDGETS" v-if="shouldGoBackButtonBeDisplayed">Client's account</span>
                          <span data-localize="sidebar.nav.WIDGETS" v-if="!shouldGoBackButtonBeDisplayed">Account details</span>
                        </router-link>
                      </li>
                      <li 
                        v-if="isFinancialAdvisor && activeAccount.primaryInvestorId !== user.id" 
                        class="action-widget" 
                        id="go-to-profile widget"
                      >
                         <router-link 
                          :to="{ 
                            name: 'EditUserProfileByAdvisor', 
                            params:{ userId: activeAccount.primaryInvestorId } 
                          }"
                          title="Profile information" 
                          class="action-link"
                        >
                          <em class="icon-user"></em>
                          <span data-localize="sidebar.nav.WIDGETS">Client's profile</span>
                        </router-link>
                      </li>

                      <li v-if="!irAdmin && user.id !== undefined" class="action-widget" :class="{ disabled: !hasBeenCreatedAccount }" id="go-to-profile widget">
                         <router-link :to="{ name: 'EditUserProfile' }" title="Profile information" class="action-link">
                          <em class="icon-user"></em>
                          <span data-localize="sidebar.nav.WIDGETS">Personal information</span>
                        </router-link>
                      </li>

                      <li v-if="shouldGoBackButtonBeDisplayed" class="action-widget list-go-back">
                        <router-link :to="{ name: 'Home' }" class="list-group-item">
                          <div @click="activateAdvisorAccount">
                            <img :src="financialAdvisorAvatar" alt="Avatar" width="60" height="60" class="img-thumbnail img-circle">
                            <span>Go back to your financial advisor account</span>
                          </div>
                        </router-link>
                      </li>
                      <!-- Switch accounts -->
                      <li v-if="user.id !== undefined">

                         <div class="list-group list-group--title" v-if="sortedAccounts.length > 1">
                          <!-- list item-->
                          <h5 class="text-muted" v-if="!isFinancialAdvisor">Switch account</h5>
                          <h5 class="text-muted" v-else>Your clients' accounts</h5>
                          <!-- list item-->
                        </div>

                        <!-- START additional account item-->
                        <div v-for="(nt, index) in sortedAccounts" :key="index" class="list-group">
                        <router-link
                          v-if="nt.id !== activeAccount.id && nt.accountType !== accountTypes.ADVISOR.name"
                          :to="{ name: 'AccountSummary' }" class="list-group-item">
                          <div @click="activateAccount(nt)">
                            <!-- list item-->
                            <a class="list-group-item">
                              <div class="media-box">
                                <div class="pull-left">
                                  <img :src="getAccountImgUrl(nt.accountType)" alt="Avatar" width="60" height="60" class="img-thumbnail img-circle">
                                </div>
                                <div class="media-box-body clearfix">
                                  <p class="m0">{{ nt.accountName }}</p>
                                  <p class="m0 text-muted">
                                    <small>{{getAccountDescription(nt.accountType)}}</small>
                                  </p>
                                </div>
                              </div>
                            </a>
                            <!-- list item-->
                          </div>
                        </router-link>
                        </div>
                        <!-- END list group-->
                      </li>

                      <!-- Logout -->
                      <li>
                        <!-- START list group-->
                        <div class="list-group">
                          <!-- list item-->
                          <a @click="callLogOut" class="list-group-item list-group-item--logout">
                            <div class="media-box">
                              <div class="pull-left">
                                <em class="icon-logout fa-2x text-info"></em>
                              </div>
                              <div class="media-box-body clearfix">
                                <p class="m0">Log out</p>
                              </div>
                            </div>
                          </a>
                          <!-- list item-->
                        </div>
                        <!-- END list group-->
                      </li>
                    </ul>
                    <!-- END Dropdown menu-->
                  </li>
                  <!-- END User avatar toggle-->
               </ul>
               <!-- END Right Navbar-->
            </div>
            <!-- END Nav wrapper-->
            <!-- START Search form-->
            <form role="search" action="search.html" class="navbar-form">
               <div class="form-group has-feedback">
                  <input type="text" placeholder="Type and hit enter ..." class="form-control">
                  <div data-search-dismiss="" class="fa fa-times form-control-feedback"></div>
               </div>
               <button type="submit" class="hidden btn btn-default">Submit</button>
            </form>
            <!-- END Search form-->
         </nav>
         <!-- END Top Navbar-->
      </header>
</template>

<script>
  import {
    mapActions,
    mapState,
    mapMutations,
    mapGetters,
  } from 'vuex';
  import $ from 'jquery';

  import {
    SET_ACTIVE_ACCOUNT_ID,
    SET_LOADING_REDIRECTION,
  } from '@/store/mutation-types';

  import orderBy from 'lodash/orderBy';

  import {
    getAccounTypeProperties,
  } from '@/util';

import {
  logoutRedirectionURL,
} from '@/config/config';

  import FinancialAdvisorAvatar
    from '@/assets/img/user/img-profile-advisor.svg';

  export default {
    name: 'topNavBar',
    async beforeMount() {
      this.determineIfGoBackButtonShouldBeDisplayed();
      this.initializeAccount();
      this.loadInvestorSince(this.activeAccountId);
    },
    watch: {
      activeAccountId(id) {
        this.loadInvestorSince(id);
      },
    },
    mounted() {
      $('.user-block-toggle').dropdown();
    },
    data() {
      return {
        financialAdvisorAvatar: FinancialAdvisorAvatar,
        isFinancialAdvisor: false,
        shouldGoBackButtonBeDisplayed: false,
        investorSince: null,
      };
    },
    methods: {
      ...mapActions('app', [
        'getStaticInformation',
        'activeAccountName',
      ]),
      ...mapActions('account', [
        'setNotificationStatus',
        'getAccount',
      ]),
      loadInvestorSince(accountId) {
        if (!accountId) {
          this.investorSince = null;
          return;
        }
        this.getAccount(accountId)
          .then((account) => {
            this.investorSince = account && account.investorSince
              ? account.investorSince
              : null;
          })
          .catch(() => {
            this.investorSince = null;
          });
      },
      ...mapMutations('app', {
        setActiveAccountId: SET_ACTIVE_ACCOUNT_ID,
        setLoadingRedirection: SET_LOADING_REDIRECTION,
      }),
      toggleSidebar() {
        this.$emit('toggle-drawer');
      },
      initializeAccount() {
        const storeActiveAccount = JSON.parse(sessionStorage.getItem('activeAccount'));

        if (!storeActiveAccount) {
          return;
        }

        this.setActiveAccountId(storeActiveAccount);
      },
      getAccountImgUrl(type) {
        if (!type) {
          return require('../assets/img/user/img-profile-default.svg');// eslint-disable-line
        }
        const accountTypeIcon = `${getAccounTypeProperties(type).icon}`;
        return require(`@/assets/img/user/${accountTypeIcon}.svg`); // eslint-disable-line
      },
      getAccountDescription(type) {
        if (!type) {
          return 'Individual Investor';// eslint-disable-line
        }
        return getAccounTypeProperties(type).text;
      },
      determineIfGoBackButtonShouldBeDisplayed() {
        const { accounts, userType } = this.user;

        const advisorAccount = accounts
          .find(account => account.accountType === this.accountTypes.ADVISOR.name);

        let isActiveAccountOfAdvisorType = false;

        if (advisorAccount) {
          isActiveAccountOfAdvisorType = (this.activeAccountId === advisorAccount.id);
        }

        this.isFinancialAdvisor = (userType === this.userTypes.FINANCIAL_ADVISOR.name);

        this.shouldGoBackButtonBeDisplayed = (
          this.isFinancialAdvisor && !isActiveAccountOfAdvisorType
        );
      },
      activateAdvisorAccount() {
        const { accounts } = this.user;

        const advisorAccount = accounts
          .find(account => account.accountType === this.accountTypes.ADVISOR.name);

        this.activateAccount(advisorAccount);
      },
      activateAccount(account) {
        this.setActiveAccountId(account);
        this.initializeAccount();
        this.setNotificationStatus('init');
        this.$emit('force-update');
        this.determineIfGoBackButtonShouldBeDisplayed();
      },
      callLogOut() {
        return this.$cognitoAuth.logout()
          .then(() => this.getStaticInformation())
          .then(() => {
            this.setLoadingRedirection();
            window.location.href = logoutRedirectionURL;
          });
      },
    },
    computed: {
      ...mapState('app', [
        'activeAccount',
        'activeAccountId',
        'accountTypes',
        'irAdmin',
        'user',
        'userTypes',
        'loadingRedirection',
      ]),
      ...mapGetters('app', [
        'hasBeenCreatedAccount',
      ]),
      sortedAccounts() {
        return orderBy(this.user.accounts, [(account) => {
          const name = account.accountName;
          return name ? account.accountName.toLowerCase() : '';
        }], ['asc']);
      },
    },
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

  .list-group-item {
    cursor: pointer;
    text-decoration: none;
  }

  /* Styles for account dropdown */

  .dropdown-list--account {
    padding: 5px 0 0;
    display: flex;
    flex-direction: row;
    margin-right: 20px;
    align-items: center;
    background: transparent!important;
    &:hover, &:active {
      background: transparent!important;
      color: white!important;
    }
    .icon-arrow-down {
      transition: all .2s ease-in-out;
    }
  }

  .dropdown-list--account__info {
    display: flex;
    flex-direction: column;
    text-align: right;
  }

  .user-block-investor-since {
    font-size: 11px;
    opacity: 0.8;
  }

  .dropdown-list--account__icon {
    margin-left: 20px;
  }

  #user-block-toggle{
    strong {
      margin: 0;
    }
  }

  /* Overrides for dropdown styles from theme  */

  .topnavbar .navbar-nav > .open > #user-block-toggle,
  .topnavbar .navbar-nav > .open > #user-block-toggle:hover,
  .topnavbar .navbar-nav > .open > #user-block-toggle:focus {
    box-shadow: none;
    color: white;
  }

  .topnavbar .navbar-nav > li > a:hover,
  .topnavbar .navbar-nav > .open > a:hover,
  .topnavbar .navbar-nav > li > a:focus,
  .topnavbar .navbar-nav > .open > a:focus {
    color: white;
  }


  .nav-wrapper .navbar-nav.navbar-right .open .dropdown-menu {
    // for mobile screns top should be 50px
    @media (max-width: 768px) {
      top: 50px;
      left: auto;
      right: 0;
    }
    top: 65px;
    width: 310px;
    animation: dropdownEntrance .4s ease-in-out;
  }

  .dropdown-list.open {
    .icon-arrow-down {
      transform: rotate(180deg);
    }
  }

  /* Styles for list item - type of accounts  */

  .media-box-body {
    display: flex;
    height: 60px;
    justify-content: center;
    flex-direction: column;
    color: #666;
    font-size: 1.15em;
    p {
      font-weight: 600;
    }
    small {
      font-weight: normal;
    }
  }

  .list-group {
    border-top: 1px solid #EEE;
  }

  .list-group-item {
    position: relative;
    .current-check {
      position: absolute;
      top: 0;
      bottom: 0;
      right: 12px;
      margin: auto;
      height: 20px;
      em {
        color: #558c1d;
      }
    }
  }

  .list-group--title {
    padding-left: 12px;
    h5 {
      font-weight: bold;
    }
  }

  .list-group-item--logout {
    .media-box-body {
      color: #00788d;
    }
    .pull-left {
      padding-top: 15px;
      width: 60px;
      text-align: center;
      .icon-logout {
        display: block;
        transform: rotate(180deg);
      }
    }
  }

  .list-group-item--current {
    .media-box-body {
      color: #232323;
    }
  }

  div.list-group-item {
    cursor: default;
  }

  .action-widget:hover {
    cursor: pointer;
  }

  .action-widget {
    font-size: 14px;
  }
  .action-widget em {
    color: #158495;
    margin-right: 15px;
  }

  .action-widget span {
    color: #158495;
  }

  .action-link {
    padding: 10px 20px;
  }

  li.list-go-back {
    border-top: 1px solid #EEE;
    a {
      padding-top: 10px;
      padding-bottom: 10px;
    }
    span {
      width: 200px;
      white-space: normal;
      margin-left: 10px;
      height: 60px;
      display: inline-block;
      top: 10px;
      position: relative;
    }
  }

  .list-group a:hover div a,
  .list-group a:focus div a {
    background-color: #f5f5f5;
  }

  @keyframes dropdownEntrance {
    0%    { top: 125px; opacity: 0; }
    100%  { top: 65px; opacity: 1; }
  }

  /* Hamburger menu styles */
  .hamburger-menu {
    display: none;
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 10px;
    margin-right: 15px;
    flex-direction: column;
    justify-content: space-around;
    height: 40px;
    width: 40px;
  }

  .hamburger-icon {
    display: block;
    width: 25px;
    height: 3px;
    background-color: #fff;
    border-radius: 2px;
    transition: all 0.3s ease-in-out;
  }

  @media (max-width: 1024px) {
    .hamburger-menu {
      display: flex;
    }

    .navbar-header {
      background-color: #00788d;
      background-image: none;
      display: flex;
      align-items: center;
      width: 100%;
    }

    .navbar-brand {
      flex: 1;
      display: flex;
      justify-content: flex-end
    }
  }

</style>



// WEBPACK FOOTER //
// TopNavBar.vue?0c41271c